export default {
  header: 'Seite mit ungespeicherten Änderungen verlassen?',
  message: 'Beim Verlassen dieser Seite gehen alle ungespeicherten Änderungen verloren.',
  leavePage: 'Seite verlassen',
  stay: 'Bleiben',
};
